import { Component } from "@angular/core";

import { CustomerServiceContactComponent } from "@hermes/hermes-web-fragments-customer-service-contact";

@Component({
    selector: "h-footer-here-to-help-deprecated",
    imports: [CustomerServiceContactComponent],
    templateUrl: "./footer-here-to-help-deprecated.component.html",
    styleUrls: ["./footer-here-to-help-deprecated.component.scss"],
})
export class FooterHereToHelpDeprecatedComponent {}
